import styled from 'styled-components';
import theme from '../theme';
import fn from '../../helpers/fn';

export default fn(__filename, styled.h1`
  color: ${theme.colors.gray3};
  font-size: 21px;
  font-weight: 400;
  opacity: .95;
  text-align: center;
  width: auto;
  display: inline-block;

  @media screen and (min-width: 640px) {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
  }
  @media screen and (max-width: 640px) {
    font-size: 18px;
  }
`);



// WEBPACK FOOTER //
// ./src/components/headings/PageTitle.js